import axios from "axios";
import * as CookieService from "../Cookie/CookieService";

const path = '/api/v1';

export function getClassroomList(pageVO, classroomName) {
    let setParam = '/api/v1/classroom?';
    if (classroomName != undefined && classroomName != null) {
        setParam += 'classroomName=' + classroomName + '&';
    }
    if (pageVO != null) {
        setParam += 'page=' + pageVO.page + '&size=' + pageVO.size + '&sort=' + pageVO.sortBy + ',' + pageVO.direction;
    }

    return axios.get(setParam, CookieService.setHeaders());
}

export function duplicateClassroomCheck(classroomName) {
    const uriEncoded = encodeURI('/api/v1/classroom/duplicate?classroomName=' + classroomName);
    return axios.get(uriEncoded, CookieService.setHeaders());
}

export function createClassroomAndMappingStudent(classroomName, studentListVO) {
    const uriEncoded = encodeURI('/api/v1/classroom?classroomName=' + classroomName);
    return axios.post(uriEncoded, studentListVO, CookieService.setHeaders());
}

export function updateClassroomAndMappingStudent(classroomName, originClassroomName, studentListVO) {
    const uriEncoded = encodeURI('/api/v1/classroom?classroomName=' + classroomName + '&originClassroomName=' + originClassroomName);
    return axios.put(uriEncoded, studentListVO, CookieService.setHeaders());
}

export function deleteClassroomAndMappingStudent(classroomName) {
    const uriEncoded = encodeURI('/api/v1/classroom?classroomName=' + classroomName);
    return axios.delete(uriEncoded, CookieService.setHeaders());
}

export function getClassroomCategory() {
    return axios.get("/api/v1/classroom/category", CookieService.setHeaders());
}

export function getStudentList(classroomName) {
    const uriEncoded = encodeURI('/api/v1/classroom/students?classroomName=' + classroomName);
    return axios.get(uriEncoded, CookieService.setHeaders());
}

export function saveVideo(classroomName, formData) {
    return axios.post(path.concat('/classroom/upload?classroomName=' + classroomName), formData, CookieService.setHeaders());
}



// WEBPACK FOOTER //
// ./src/services/Teacher/AdminClassroomService.js